import { useTranslation } from 'react-i18next';
import { LogoContentHeader } from '../../components/LogoContentHeader';
import { SplitPageLayout } from '../../components/SplitPageLayout';
import { Link } from 'react-router-dom';

import classes from './VerifyAccount.module.css';

export const VerifyAccount = () => {
  const { t } = useTranslation();

  return (
    <SplitPageLayout
      left={
        <div className={classes.container}>
          <LogoContentHeader
            title={t('verifyAccount.title')}
            subtitle={t('verifyAccount.subtitle')}
          />
          <Link to="/">{t('verifyAccount.goToLogin')}</Link>
        </div>
      }
      backgroundImagePath="/trustpulse.svg"
    />
  );
};
